import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Youtube, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-white border-t border-gray-200 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-6 mb-6">
          {/* Logo & Description */}
          <div className="col-span-2">
            <Link to="/" className="flex items-center mb-3">
              <img
                src="/logo-azul-transparente.png"
                alt="ChatAlfa"
                className="h-24"
              />
            </Link>
            <p className="text-gray-500 text-sm mb-4 max-w-xs">
              {t('footer.description')}
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#3b82f6] hover:text-white transition-colors text-gray-600">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#3b82f6] hover:text-white transition-colors text-gray-600">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#3b82f6] hover:text-white transition-colors text-gray-600">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#3b82f6] hover:text-white transition-colors text-gray-600">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#3b82f6] hover:text-white transition-colors text-gray-600">
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-3 text-sm">{t('footer.product')}</h4>
            <ul className="space-y-2">
              <li><Link to="/features" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.features')}</Link></li>
              <li><Link to="/pricing" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.pricing')}</Link></li>
              <li><Link to="/integrations" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.integrations')}</Link></li>
              <li><Link to="/api" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.api')}</Link></li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-3 text-sm">{t('footer.company')}</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.aboutUs')}</Link></li>
              <li><Link to="/blog" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.blog')}</Link></li>
              <li><Link to="/affiliate" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.affiliates')}</Link></li>
              <li><Link to="/contact" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.contact')}</Link></li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-3 text-sm">{t('footer.resources')}</h4>
            <ul className="space-y-2">
              <li><Link to="/docs" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.docs')}</Link></li>
              <li><Link to="/templates" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.templates')}</Link></li>
              <li><Link to="/success-stories" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.successStories')}</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-3 text-sm">{t('footer.legal')}</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms" className="text-gray-500 hover:text-[#3b82f6] transition-colors text-sm">{t('footer.terms')}</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-4 border-t border-gray-200 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-sm">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-gray-400">{t('footer.officialPartner')}</span>
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 bg-[#25D366] rounded-full flex items-center justify-center">
                <MessageCircle className="w-3 h-3 text-white" />
              </div>
              <span className="text-xs text-gray-500">WhatsApp Business API</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
